// extracted by mini-css-extract-plugin
module.exports = {"_player":"styles__player__gURVr"};